import { Outlet } from 'react-router';
import { usePrefetchLanguages } from '../apiHooks/useLanguagesQuery';

export const PrefetchLanguages: React.FC = () => {
  usePrefetchLanguages();
  return <Outlet />;
};
